// extracted by mini-css-extract-plugin
module.exports = {"payment__makePaymentBox":"styles_payment__makePaymentBox__Y-R0b"};